import axiosInstance from '../../Api/axiosInstance';

const API_URL = '/integrations/gmail';

const call = async (request, fallback) => {
	try {
		const response = await request();
		return response.data;
	} catch (error) {
		throw new Error(error.response?.data?.msg || fallback);
	}
};

export const getGmailStatus = () =>
	call(() => axiosInstance.get(`${API_URL}/status`), 'Error checking Gmail.');

/** Google consent URL; Google sends the browser back to `returnUrl` afterwards. */
export const getGmailAuthUrl = (returnUrl) =>
	call(
		() => axiosInstance.get(`${API_URL}/auth-url`, { params: { returnUrl } }),
		'Error starting the Gmail connection.',
	);

export const disconnectGmail = () =>
	call(() => axiosInstance.delete(API_URL), 'Error disconnecting Gmail.');

/** Pull bounce/reply updates from Gmail for outreach leads. */
export const syncGmailInbox = () =>
	call(() => axiosInstance.post(`${API_URL}/sync`), 'Error syncing Gmail.');
